import {isCopilot} from '@github-ui/assignees/copilot-user'

export interface CommentAuthorIdentity {
  login: string
  linkable: boolean
}

/**
 * Returns true when a comment author's profile can be linked to. Bots and agents
 * (Copilot, `[bot]` accounts) are rendered as plain text rather than links.
 */
export function isLinkableAuthorLogin(login: string): boolean {
  return !isCopilot(login) && !login.endsWith('[bot]')
}

/**
 * Returns the identity to attribute an issue comment to. The comment payload
 * doesn't flag the viewer's own comments, so callers pass the current user login
 * to render an unlinked "You" when it matches the author.
 */
export function getIssueCommentAuthor(
  authorLogin: string,
  currentUserLogin: string | undefined,
): CommentAuthorIdentity {
  if (currentUserLogin && authorLogin === currentUserLogin) return {login: 'You', linkable: false}

  return {login: authorLogin, linkable: isLinkableAuthorLogin(authorLogin)}
}
